<template>
  <div id="app" style="font-size: 14px">
      <router-view></router-view>
  </div>
</template>

<script>

    import PageHeader8 from './components/PageHeader8'
    import NavBar8 from './components/NavBar8'

    export default {
        name      : 'app',
        data() {
            return {

            }
        },
        components : {
            PageHeader8,
            NavBar8,
        }
    }
</script>




// WEBPACK FOOTER //
// src/App.vue